// extracted by mini-css-extract-plugin
module.exports = {"restore-template":"restore-template--26d2d0","restoreTemplate":"restore-template--26d2d0"};